module.exports = __webpack_public_path__ + "static/img/DSK.1f38e016.png";